/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Api_Key_Validation_HintInputs */



/**
* | output |
* | --- |
* | "We'll verify the key against the upstream API before saving. No credits are consumed." |
*
* @param {Integrations_Api_Key_Validation_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_api_key_validation_hint = /** @type {((inputs?: Integrations_Api_Key_Validation_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Api_Key_Validation_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Schlüssel wird vor dem Speichern gegen die Upstream-API geprüft. Es werden keine Credits verbraucht.")
	return /** @type {LocalizedString} */ ("We'll verify the key against the upstream API before saving. No credits are consumed.")
});